import React, { createContext, useContext, useState, useEffect } from 'react';
import { doc, onSnapshot } from 'firebase/firestore';
import { db, appId } from '../firebase/config';

const ThemeContext = createContext();

export const useTheme = () => useContext(ThemeContext);

export const ThemeProvider = ({ children }) => {
    const [theme, setTheme] = useState({ 
        corPrimaria: '#f59e0b', // Cor padrão
        imagemFundo: 'https://sp-ao.shortpixel.ai/client/to_webp,q_glossy,ret_img/https://vintagepraia.pt/wp-content/uploads/2018/12/sushi01-1-1.jpg' // Imagem padrão
    });

    useEffect(() => {
        const themeDocRef = doc(db, `artifacts/${appId}/public/data/configuracoes`, 'tema');
        
        const unsubscribe = onSnapshot(themeDocRef, (docSnap) => {
            if (docSnap.exists()) {
                // Mistura os dados do firebase com os padrão para garantir que nada falha
                const firestoreTheme = docSnap.data();
                setTheme(prevTheme => ({ ...prevTheme, ...firestoreTheme }));
            }
        }, (error) => {
            console.error("Erro ao carregar o tema em tempo real:", error);
        });

        return () => unsubscribe();
    }, []);

    // Aplica a cor primária como uma variável CSS global
    useEffect(() => {
        const root = document.documentElement;
        if (theme.corPrimaria) {
            root.style.setProperty('--color-primary', theme.corPrimaria);
        }
    }, [theme.corPrimaria]);

    return (
        <ThemeContext.Provider value={{ theme }}>
            {children}
        </ThemeContext.Provider>
    );
};
